import { useEffect, useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";

// DATA LIMITE EARLY BIRD — placeholder à espera da data oficial do cliente
const EARLY_BIRD_DEADLINE = new Date("2026-10-31T23:59:59+01:00");

const pad = (n) => String(n).padStart(2, "0");

export const EarlyBirdCountdown = ({ className = "mt-6", compact = false }) => {
    const { t } = useLanguage();
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, []);

    const diff = EARLY_BIRD_DEADLINE.getTime() - now;
    if (diff <= 0) return null; // no fim do prazo, o countdown desaparece

    const units = [
        { id: "days", valor: pad(Math.floor(diff / 86400000)), label: t.hero.countdown.dias },
        { id: "hours", valor: pad(Math.floor((diff % 86400000) / 3600000)), label: t.hero.countdown.horas },
        { id: "mins", valor: pad(Math.floor((diff % 3600000) / 60000)), label: t.hero.countdown.min },
        { id: "secs", valor: pad(Math.floor((diff % 60000) / 1000)), label: t.hero.countdown.seg },
    ];

    return (
        <div className={`${className} inline-block border border-[#c9a24b]/40 bg-[#070503]/50 backdrop-blur-sm ${compact ? "px-4 py-2.5" : "px-5 py-3"}`} data-testid="early-bird-countdown">
            <p className="font-caps text-[9px] tracking-[0.3em] uppercase text-[#d19a3f]" data-testid="early-bird-label">
                {t.hero.countdown.label}
            </p>
            <div className={`${compact ? "mt-1" : "mt-2"} flex items-baseline`} data-testid="early-bird-units">
                {units.map((u, i) => (
                    <div key={u.id} className="flex items-baseline">
                        <div className={`text-center ${compact ? "min-w-[2rem]" : "min-w-[2.4rem]"}`}>
                            <span className={`font-display font-medium gold-text ${compact ? "text-xl" : "text-2xl sm:text-3xl"} tabular-nums leading-none`} data-testid={`early-bird-${u.id}`}>
                                {u.valor}
                            </span>
                            <span className={`block ${compact ? "mt-0.5" : "mt-1"} font-caps text-[8px] tracking-[0.25em] uppercase text-[#efe6d6]/55`}>{u.label}</span>
                        </div>
                        {i < units.length - 1 && (
                            <span className={`mx-2 font-display gold-text ${compact ? "text-base" : "text-xl"} leading-none`} aria-hidden="true">:</span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
